import { NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import cx from 'classnames'

export const PreviewComponent = (props: NodeViewProps) => {
  const { url, title, src } = props.node.attrs

  const className = cx(
    'flex bg-gray-100 rounded-sm p-4 text-sm mb-6 items-center gap-4 hover:bg-gray-200',
    {
      'ring-2 ring-blue-300 ring-inset': props.selected,
    }
  )

  return (
    <NodeViewWrapper contentEditable={false}>
      <a
        className={className}
        href={url}
        rel="noopener noreferrer nofollow"
        target="_blank"
        data-embed-preview
      >
        <img
          src={src}
          alt={`${title} Preview`}
          className="w-24 overflow-hidden rounded-sm"
        />
        <span>{title}</span>
      </a>
    </NodeViewWrapper>
  )
}
